void 0;
var cemf = cemf || {
    js: {}
};

cemf.js.Web = function () { }
cemf.js.Web.prototype.url = "";
cemf.js.Web.prototype.link = "";
cemf.js.Web.prototype.external_reference = "";
cemf.js.Web.prototype.utility = null;

cemf.js.Web.prototype.start = function () {
    var self = this;
    self.utility = new cemf.js.Utility();
    self.utility.messageStart();
    // self.utility.start();
    self.utility.startWeb();

}

cemf.js.Web.prototype.startRequest = function () {
    var self = this;

    request();
    var rqInterval = setInterval(request, 5000);

    function request() {
        var flashClass = "ajax_response";
        var flash = $("." + flashClass);

        void 0;

        $.ajax({
            method: "POST",
            url: self.url,
            dataType: "json",
            data: {
                external_reference: self.external_reference,
            },
            beforeSend: function () {
                void 0;
            },
            success: function (response) {
                void 0;
                void 0;


                //message
                if (response.message) {
                    self.utility.ajaxMessage(response.message, 3);

                }
                if (response.error == true) {
                    clearInterval(rqInterval);
                }

                //redirect
                if (response.redirect) {
                    window.location.href = response.redirect;
                }

                //Atualizando Inteface
                if (response.payment) {
                    $('#status').html(response.payment.status_pt);
                    $('#title-status').html(response.payment.status_title);
                    $("#info-status").html(response.payment.status_info);

                    if (response.payment.status == 'approved') {
                                clearInterval(rqInterval);
                                $("#btn-pay").addClass("none");
                                $("#btn-support").addClass("none");
                                $("#status")
                                    .addClass("--blue-light")
                                    .removeClass("--color-secondary");
                                $("#btn-portal").removeClass("none");
                      
                    } else if (response.payment.status == 'pending' ||
                        response.payment.status == 'in_process') {
                            $("#btn-pay").addClass("none");
                            $("#btn-support").addClass("none");

                    } else if (response.payment.status == 'rejected' ||
                        response.payment.status == 'cancelled') {

                        clearInterval(rqInterval);
                        $("#btn-pay").removeClass("none");
                        $("#btn-support").removeClass("none");
                        $("#status")
                            .addClass("--red")
                            .removeClass("--color-secondary");
        

                    } else if (response.payment.status == 'refunded') {

                        clearInterval(rqInterval);
                        $("#btn-support").removeClass("none");
                        $("#btn-pay").addClass("none");
                    

                    } else if (response.payment.status == 'charge_back') {

                        clearInterval(rqInterval);
                        $("#btn-support").removeClass("none");
                        $("#btn-pay").addClass("none");
       

                    }


                }
            },
            complete: function (response) {
                void 0;

            },
            error: function (event) {

                self.utility.ajaxMessage("<div class='message error icon-warning'>Desculpe mas não foi possível processar sua requisição...</div>", 5);

            }

        });
    }
}
void 0;

$(document).ready(function($) {
    var $utility = new cemf.js.Utility();
    $utility.startWeb();
});